// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1D95d","signatureBlock":"Footer_signatureBlock__mq2hR","signature":"Footer_signature__1bUji"};